import ChangePasswordCtrl from './change-password.js';

export default class extends ChangePasswordCtrl {

    // @ngInject
    constructor(responseHandler, authService, $mdDialog) {
        super(responseHandler, authService);
        this.$mdDialog = $mdDialog;
    }

    submit() {
        let promise = super.submit();
        promise.then((response) => {
            this.$mdDialog.hide(response);
        });
    }

    hide() {
        this.$mdDialog.cancel();
    }
}



// WEBPACK FOOTER //
// ./user/change-password/change-password-dialog.js